export default __webpack_public_path__ + "static/media/wrist.96d3fd01.svg";